function addFullscreenListener(elem) {
  //Toggle fullscreen on click.
  elem.addEventListener("click", function () {
    if (!document.fullscreenElement) {
      elem.requestFullscreen();
    } else {
      document.exitFullscreen();
    }
  });
}

const dropArea = document.getElementById("drop-area");
let output = document.createElement("div");
output.style.backgroundColor = "#151515";
output.id = "output";
output.innerHTML = "<p>Images will appear here. </p>";
dropArea.after(output);

let fileInput = document.getElementById("fileinput");

const addDownloadButton = (elem, file) => {
  let downloadElement = document.createElement("div");
  downloadElement.textContent = "Download";
  downloadElement.classList.add("download");
  downloadElement.addEventListener("click", async () => {
    const splittedFileName = file.name.split(".");
    if (splittedFileName[splittedFileName.length - 1].toLowerCase() === "heic") {
      const bf = await file.arrayBuffer();
      const outputBuffer = await self.heicConvert({
        buffer: new Uint8Array(bf),
        format: self.HEIC_TO_FORMAT,
        quality: 1,
      });

      const pngBlob = new Blob([outputBuffer], {type: self.HEIC_TO_FORMAT === "PNG" ? "image/png" : "image/jpeg"});
      self.fileSaver.saveAs(pngBlob);
    } else {
      self.fileSaver.saveAs(file);
    }
  });

  elem.appendChild(downloadElement);
};

const addErrorMessageButton = (elem, message) => {
  const errorMessageElement = document.createElement("div");
  errorMessageElement.classList.add("error-message");

  const errorMessageContentElement = document.createElement("p");
  errorMessageContentElement.textContent = message;

  errorMessageElement.appendChild(errorMessageContentElement);
  elem.appendChild(errorMessageElement);
};

fileInput.addEventListener("change", async function () {
  while (output.firstChild) {
    output.firstChild.remove();
  }

  let files = fileInput.files;

  let maxThreads = (navigator?.hardwareConcurrency || 1) / 2; //Divide by two to try and mitigate against hyperthreading. Some browsers factor it in, others don't.
  let currentProcesses = [];
  const errorMessagesElement = document.querySelector(".error-messages");
  errorMessagesElement.textContent = "";

  if (files.length > self.MAX_UPLOADED_FILES) {
    addErrorMessageButton(errorMessagesElement, "You cannot upload more than " + MAX_UPLOADED_FILES + " images");
    return;
  }

  for (let i = 0; i < files.length; i++) {
    if (currentProcesses.length >= maxThreads) {
      await Promise.race(currentProcesses); //Wait for at least one to finish.
    }

    let file = files[i];
    const splittedFileName = file.name.split(".");

    if (!self.SUPPORTED_FILE_EXTENSIONS.includes(splittedFileName[splittedFileName.length - 1].toLowerCase())) {
      addErrorMessageButton(errorMessagesElement, "The file " + file.name + " has wrong extension");
      continue;
    }

    if (file.size > self.MAX_SIZE_IMAGE) {
      addErrorMessageButton(
        errorMessagesElement,
        "The file " + file.name + " size exceeds the limit. The limit is " + MAX_SIZE_IMAGE / 1024 / 1024 + " MB"
      );
      continue;
    }

    let fileOutputElem = document.createElement("div");
    fileOutputElem.classList.add("file-output");
    output.appendChild(fileOutputElem);

    let info = document.createElement("p");
    info.classList.add("info");
    info.innerHTML = `Processing ${file.name} (${file.size} bytes)... `;
    fileOutputElem.appendChild(info);
    let start = Date.now();

    let promise = new Promise((resolve, reject) => {
      //We'll try HEIC decode. If HEIC fails, then we will try adding directly.
      let worker = new Worker("packages/worker.js");

      function endWorker() {
        worker.terminate();
        currentProcesses.splice(currentProcesses.indexOf(promise), 1);
        resolve();
      }

      worker.addEventListener("message", function (message) {
        let obj = message.data;

        if (obj === "Done") {
          return endWorker();
        } else if (obj === "Crash") {
          //Hopefully it's another type of image, otherwise this won't work.
          let url = URL.createObjectURL(file);
          let img = document.createElement("img");
          img.src = url;
          fileOutputElem.appendChild(img);

          elem = img;
          addFullscreenListener(elem);
          addDownloadButton(fileOutputElem, file);
          info.innerHTML = `Not HEIC - Attempted to Render ${file.name} (${file.size} bytes) in ${Date.now() - start}ms `;
          return endWorker();
        }

        let canvas = document.createElement("canvas");
        canvas.width = obj.width;
        canvas.height = obj.height;
        let ctx = canvas.getContext("2d");
        let imageData = new ImageData(new Uint8ClampedArray(obj.data), obj.width, obj.height);
        console.log(imageData);
        ctx.putImageData(imageData, 0, 0);
        //Put in paragraph tags so it's centered.
        let p = document.createElement("p");
        p.appendChild(canvas);
        fileOutputElem.appendChild(p);
        elem = canvas;
        addFullscreenListener(elem);
        info.innerHTML = `Rendered ${file.name} (${file.size} bytes) in ${Date.now() - start}ms `;
        addDownloadButton(fileOutputElem, file);
      });

      worker.postMessage(file);
    });
    currentProcesses.push(promise);
  }
});

//May be automatically added if the page is reloaded, etc.
if (fileInput.files.length > 0) {
  fileInput.dispatchEvent(new Event("change"));
}
